import type { RealAndLegal } from '../types/pricingApiTypes';

export type InvoiceBuyerInfo = {
  name: string;
  economicCode: string;
  nationalId: string;
  postalCode: string;
  address: string;
};

const EMPTY_VALUE = '-';

function orDash(value: string | null | undefined): string {
  return value?.trim() ? value.trim() : EMPTY_VALUE;
}

export function resolveInvoiceBuyer(
  realAndLegal: RealAndLegal | null | undefined,
  fallback: InvoiceBuyerInfo,
): InvoiceBuyerInfo {
  if (!realAndLegal) {
    return fallback;
  }

  const addressParts = [
    realAndLegal.province,
    realAndLegal.city,
    realAndLegal.address,
  ].filter((part) => part?.trim());

  return {
    name: orDash(realAndLegal.name) === EMPTY_VALUE ? fallback.name : realAndLegal.name.trim(),
    economicCode: orDash(realAndLegal.economical_number),
    nationalId: orDash(realAndLegal.national_id),
    postalCode: orDash(realAndLegal.postal_code),
    address: addressParts.length > 0 ? addressParts.join('، ') : EMPTY_VALUE,
  };
}
